import clsx from 'clsx';
import LinkIcon from 'components/LinkIcon/LinkIcon';
import { section_links } from 'root/data/section_links';
import './HeaderSocials.scss';

const HeaderSocials = ({ active, dispatchActive }) => {
  function dispatch(i) {
    if ( i !== active ) {
      dispatchActive(i)
    }
  }

  return (
    <div className="header-socials">
      {Object.entries(section_links).map(([title, _]) => (
        <div
          className={clsx('header-socials__item', ( active === title ) && '--active')}
          key={title}
          onClick={() => dispatch(title)}
        >
          <LinkIcon className="header-socials__btn">
            <img src={_[0]} alt="icon" />
          </LinkIcon>
          <p className="header-socials__name">
            Galaxy "<span>{_[1]}</span>"
          </p>
        </div>
      ))}
    </div>
  );
};

export default HeaderSocials;
